import { render } from "./cancelReserveModel.vue?vue&type=template&id=13051356&scoped=true"
import script from "./cancelReserveModel.vue?vue&type=script&lang=js"
export * from "./cancelReserveModel.vue?vue&type=script&lang=js"

import "./cancelReserveModel.vue?vue&type=style&index=0&id=13051356&lang=scss&scoped=true"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13051356"]])

export default __exports__